module.exports = __webpack_public_path__ + "img/ts-bg.90d13b9b.jpg";